import { Chip } from "@mui/material";

export const StatusChip = (value, id) => {
  if (value === "active") {
    return (
      <Chip
        label={value}
        sx={{
          backgroundColor: "#ECFDF3",
          color: "#067647",
          border: "1px solid #ABEFC6",
          borderRadius: "6px",
          textTransform: "capitalize",
          fontSize: "14px",
          padding: "2px 8px 2px 8px",
          height: "24px",
          fontWeight: 500,
        }}
      />
    );
  } else if (value === "onboarding") {
    return (
      <Chip
        label={value}
        sx={{
          backgroundColor: "#EFF8FF",
          color: "#175CD3",
          border: "1px solid #B2DDFF",
          borderRadius: "6px",
          textTransform: "capitalize",
          fontSize: "14px",
          fontWeight: 500,
          padding: "2px 8px 2px 8px",
          height: "24px",
        }}
      />
    );
  } else if (value === "renewal" || value === "trial ending") {
    return (
      <Chip
        label={value}
        sx={{
          backgroundColor: "#FFFAEB",
          color: "#B54708",
          border: "1px solid #FEDF89",
          borderRadius: "6px",
          textTransform: "capitalize",
          fontSize: "14px",
          fontWeight: 500,
          padding: "2px 8px 2px 8px",
          height: "24px",
        }}
      />
    );
  } else if (value === "inactive") {
    return (
      <Chip
        label={value}
        sx={{
          backgroundColor: "#FEF3F2",
          color: "#B42318",
          border: "1px solid #FECDCA",
          borderRadius: "6px",
          textTransform: "capitalize",
          fontSize: "14px",
          fontWeight: 500,
          padding: "2px 8px 2px 8px",
          height: "24px",
        }}
      />
    );
  }
};
